import swal from "sweetalert";
import { SwalOptions } from "sweetalert/typings/modules/options";
import { $ } from "../utils/dom";
import { Template } from "./template";

interface IModalFunction {
  [key: string]: (param?: any) => Promise<any>;
}

export class Modal {
  private static singleton: Modal;
  private template: Template;
  private modals: IModalFunction;

  constructor() {
    this.template = new Template("#js__template--setting");
  }

  public show(type: string, param?: any): Promise<any> {
    return this.modals[type](param);
  }

  public init() {
    this.modals = {
      cacheClear: () =>
        swal("缓存清除成功", "解析错误的地址可以重新解析了", "success"),
      help: (isNotFirstVisit = true) => {
        const config: Partial<SwalOptions> = {
          title: "欢迎使用文献解析助手",
          text: `
              该文献解析服务仍然为测试中版本，请大家使用的时候务必注意以下几点：
    
              1. 暂时不要将此工具大范围传播。个人维护的精力有限，而维护服务器的持续运行与高可用性需要一定的成本，在现在的带宽较窄的情况下，一旦访问量超过一定限制，访问速度必然降低。
    
              2. 不要一次性解析太多文献，一般控制在10篇之内为佳。大量的文献同时发送会降低解析速度，随后如果一次性全部打开会对浏览器造成较大压力，甚至卡死。更严重的是，同时打开大量文献有可能被文献数据库判断为访问过于频繁导致封禁。

              3. 使用 DOI 查询文章时，由于无法判断所属杂志，故不提供 Sci-Hub 解析服务。如果需要解析到 Sci-Hub，请直接查询引用格式，如：J. Am. Chem. Soc., 2018, 140, 3569–3573
              
              4. 当您觉得很常见的期刊而该服务却无法解析，或者出现其他bug时，可以直接与我取得联系，一般来说24小时之内即有更新修复。
      
              联系方式：nikaple@qq.com
              `,
          icon: "info",
          buttons: [false]
        };
        if (isNotFirstVisit) {
          config.buttons = {
            confirm: {
              text: "不再显示",
              value: true,
              visible: true,
              className: "",
              closeModal: true
            }
          };
        }
        return swal(config);
      },
      notFound: () =>
        swal("未找到解析的文献", "看看参考文献输对了吗？", "error"),
      failed: () =>
        swal(
          "全部解析失败了：（",
          "如果是服务器故障可以联系nikaple@qq.com",
          "error"
        ),
      setting: () => {
        const modalNode = this.template.$(".modal");
        if (!modalNode) {
          return Promise.reject("error");
        }
        const settingNode = modalNode.cloneNode(true);
        return swal({
          buttons: {
            clear: {
              text: "清除缓存",
              value: "clear"
            }
          },
          content: {
            element: settingNode
          }
        });
      },
      hasDoi: () => {
        return swal("DOI 解析无法使用 Sci-Hub", "详细信息请点击右上角帮助哦", "warning")
      },
      openLinks: ({ showRetry, text }) => {
        return swal({
          buttons: {
            cancel: {
              text: "取消",
              value: null,
              visible: true,
              className: "",
              closeModal: true
            },
            retry: {
              text: "重试",
              value: "retry",
              visible: showRetry,
              closeModal: true
            },
            confirm: {
              text: "Go",
              value: true,
              visible: true,
              className: "",
              closeModal: true
            }
          },
          text
        });
      }
    };
  }

  /**
   * Creates an unique instance of AppComponent
   *
   * @readonly
   * @static
   * @type {AppComponent}
   * @memberof AppComponent
   */
  public static get instance(): Modal {
    if (!Modal.singleton) {
      Modal.singleton = new Modal();
    }
    return Modal.singleton;
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/components/modal.ts